import ServiceTemplate from '../ServiceTemplate';

const RejectedMortgage = () => {
  const serviceData = {
    title: 'משכנתא למסורבים',
    description: 'פתרונות יצירתיים ומותאמים אישית למי שנתקל בקשיים בקבלת משכנתא מהבנקים, עם דגש על מציאת פתרונות מימון חלופיים ושיפור הפרופיל הפיננסי.',
    sections: [
      {
        title: 'איך אנחנו יכולים לעזור?',
        content: 'אנחנו מתמחים במציאת פתרונות יצירתיים למקרים מורכבים. נבצע ניתוח מעמיק של המצב הפיננסי שלכם, נזהה את הגורמים לסירוב, ונבנה תכנית פעולה מותאמת אישית שתגדיל את הסיכויים שלכם לקבל משכנתא. במקרים רבים, הסירוב נובע מסיבות שניתן לפתור עם הכוונה נכונה.'
      },
      {
        title: 'מה כולל השירות?',
        content: 'השירות כולל בדיקה מקיפה של ההיסטוריה הפיננסית, איתור נקודות תורפה, בניית תכנית לשיפור הפרופיל הפיננסי, חיפוש מסלולי מימון חלופיים, וליווי צמוד בתהליך מול הבנקים. אנחנו גם נעזור בהכנת התיק לבנק באופן שיגדיל את סיכויי האישור.'
      }
    ],
    benefits: [
      'ניתוח מעמיק של סיבות הסירוב',
      'בניית תכנית לשיפור הפרופיל הפיננסי',
      'חיפוש פתרונות מימון חלופיים',
      'ליווי אישי מול הבנקים',
      'הכנת תיק בקשה מקצועי',
      'ייעוץ לשיפור כושר ההחזר'
    ],
    faqs: [
      {
        question: 'מה הסיבות הנפוצות לסירוב משכנתא?',
        answer: 'הסיבות הנפוצות כוללות: הכנסה לא מספקת, היסטוריית אשראי בעייתית, חובות קיימים, העדר הון עצמי מספק, או בעיות בהתנהלות בחשבון הבנק. לכל אחת מהסיבות הללו יש פתרונות אפשריים, ואנחנו מתמחים במציאת הפתרון המתאים לכל מקרה.'
      },
      {
        question: 'האם יש סיכוי לקבל משכנתא אחרי סירוב?',
        answer: 'בהחלט כן! סירוב מבנק אחד לא אומר שכל הבנקים יסרבו. כל בנק יש מדיניות שונה ודרישות שונות. בנוסף, עם הכנה נכונה והצגת התיק בצורה מקצועית, ניתן להגדיל משמעותית את סיכויי האישור גם בבנק שסירב בעבר.'
      },
      {
        question: 'כמה זמן לוקח לשפר את המצב כדי לקבל משכנתא?',
        answer: 'משך הזמן משתנה בהתאם לסיבת הסירוב. בחלק מהמקרים ניתן למצוא פתרון מיידי, ובמקרים אחרים נדרשת תקופת שיפור של מספר חודשים. אנחנו נבנה איתכם תכנית פעולה מפורטת עם לוחות זמנים ריאליים.'
      },
      {
        question: 'מה האפשרויות העומדות בפני מסורבי משכנתא?',
        answer: 'יש מספר אפשרויות: שיפור הפרופיל הפיננסי, חיפוש ערבים, שילוב הכנסות של בני משפחה, מציאת שותפים להלוואה, שימוש בנכסים קיימים כבטוחה, או שילוב של מספר פתרונות. אנחנו נבחן את כל האפשרויות ונמצא את השילוב האופטימלי עבורכם.'
      },
      {
        question: 'האם כדאי לנסות שוב באותו בנק שסירב?',
        answer: 'זה תלוי בסיבת הסירוב ובשינויים שנעשו מאז. לעתים עדיף לפנות לבנק אחר, ולעתים כדאי לנסות שוב באותו בנק אחרי שיפור המצב. כיועצת עצמאית, אני אוכל להמליץ על האסטרטגיה הטובה ביותר בהתאם למקרה הספציפי שלכם.'
      }
    ],
    whatsappMessage: 'שלום, נתקלתי בקשיים בקבלת משכנתא ואשמח לקבל ייעוץ מקצועי בנושא.'
  };

  return <ServiceTemplate {...serviceData} />;
};

export default RejectedMortgage; 